module.exports = __webpack_public_path__ + "img/mic.34e5bfe3.png";